export const CustomerVesselRoutes = {
    AddCustomerVessels: "CustomerVessel/AddCustomerVessels",
    ChangeCustomerVessels: "CustomerVessel/ChangeCustomerVessels",
    DoesCustomerHaveAccessToVessel: "CustomerVessel/DoesCustomerHaveAccessToVessel",
    GetCustomerVessels: "customerVessel/GetCustomerVessels",
    RemoveCustomerVessels: "customerVessel/RemoveCustomerVessels"
}